module.exports = __webpack_public_path__ + "3f2dc30973297e6d5d40d36e324790ae.svg";